var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.035 2C17.576 2 22.07 6.493 22.07 12.034s-4.492 10.034-10.034 10.034S2 17.576 2 12.034 6.493 2 12.035 2m0 1.2a8.836 8.836 0 0 0 0 17.668 8.835 8.835 0 0 0 0-17.669M12 7.5a.5.5 0 0 1 .5.5v4.714l3.072 1.537a.5.5 0 0 1-.447.895l-3.349-1.675a.5.5 0 0 1-.276-.448V8a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgClock;